<template lang="html">
  <div class="">
    <v-progress-linear
      v-show="loading"
      :indeterminate="true"
      color="#b21977"
      class="ma-0"
      height="4px"
    ></v-progress-linear>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card class="pa-3">
        <div class="font-purple">
          <div class="fa-1_2x font-bold">Confirmed your account successfully.</div>
          <div class="mt-2">
            Already have the App?<br />
            <a :href="appUrlScheme">Open fondi→</a>
          </div>
          <div class="mt-2">
            Haven't downloaded fondi yet?<br />
            <a :href="app_link" target="_blank">find fondi on {{ store }}</a>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <div v-if="failed" class="font-purple mt-3 px-2">
      <div class="fa-1_2x tiny-xs-space font-bold">
        Something wrong has happened with confirming your account.
      </div>
      <div class="mt-2">Please try either of below.</div>
      <ul>
        <li>Go back to email and click the link once again.</li>
        <li>Make another account in fondi App and confirm again with that account.</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { AppUrlScheme } from '../utils/app_utils';

export default {
  data() {
    return {
      loading: true,
      dialog: false,
      app_link: '',
      store: '',
      failed: false,
      appUrlScheme: AppUrlScheme,
    };
  },

  mounted() {
    var userAgent = window.navigator.userAgent;
    var device;
    if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
      device = 'Internet Explorer';
    } else if (userAgent.indexOf('edge') != -1) {
      device = 'Edge';
    } else if (userAgent.indexOf('iPhone') != -1) {
      device = 'iPhone';
    } else if (userAgent.indexOf('Android') != -1) {
      device = 'Android';
    } else {
      device = 'undefined';
    }
    if (device == 'iPhone') {
      this.app_link = 'https://apps.apple.com/us/app/fondi/id1479328028?mt=8'; // iOS App Store
      this.store = 'iOS App Store';
    } else if (device == 'Android') {
      this.app_link =
        'https://play.google.com/store/apps/details?id=com.Fondi.Fondi&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'; // Google Play Store
      this.store = 'Google Play Store';
    }

    setTimeout(() => {
      axios
        .post('/confirm', {
          confirmation_token: this.$route.query.token,
        })
        .then(() => {
          this.loading = true;
          this.dialog = true;
        })
        .catch((e) => {
          this.loading = false;
          this.failed = true;
          console.log(e);
        });
    }, 500);
  },
};
</script>

<style lang="css" scoped></style>
